const deepGet = (obj, props, defaultValue) => {
  if (obj === undefined || obj === null) {
    return defaultValue
  }

  const properties = typeof props === 'string' ? props.split('.') : props
  let idx = 0
  let ret = obj
  // eslint-disable-next-line no-constant-condition
  while (true) {
    ret = ret[properties[idx]]

    if (ret === undefined || ret === null) {
      return defaultValue
    }

    if (idx >= properties.length - 1) {
      return ret
    }

    idx += 1
  }
}

export default deepGet
